import { SignedInFooter } from '@chegg-me-components/signed-in-footer'
import { Config } from '@chegg-wt/core/config'

export const HOME_PAGE_FOOTER_TEST = 'home-page-footer-test'

const HomePageFooter = () => (
  <SignedInFooter
    navLinks={[
      {
        text: 'Academic Integrity',
        href: 'https://www.chegg.com/about/academic-integrity/',
        useAbsolute: true,
      },
      {
        text: 'Feedback',
        href: 'https://www.chegg.com/en/contactus/feedback',
        useAbsolute: true,
      },
      {
        text: 'Help Center',
        href: 'https://www.chegg.com/en/contactus',
        useAbsolute: true,
      },
      {
        text: 'Manage Subscription',
        href: 'https://www.chegg.com/my/orders',
        useAbsolute: true,
      },
    ]}
    legalLinks={[
      {
        text: 'Cookie Notice',
        href: 'https://www.chegg.com/en-US/cookienotice',
        useAbsolute: true,
      },
      {
        text: 'Do Not Sell My Info',
        href:
          'https://privacyportal-cdn.onetrust.com/dsarwebform/a21a74f4-2f93-44a2-a887-302a9213c997/06b040b7-49eb-464a-b19a-ea35c85c79fc.html',
        configuration: {
          elementClassName: 'ot-sdk-show-settings',
          elementId: 'ot-sdk-btn',
        },
        useAbsolute: true,
      },
      {
        text: 'General Policies',
        href: 'https://www.chegg.com/en-US/generalpolicies',
        useAbsolute: true,
      },
      {
        text: 'Global Privacy Policy',
        href: 'https://www.chegg.com/en-US/privacypolicy',
        useAbsolute: true,
      },
      {
        text: 'Honor Code',
        href: 'https://www.chegg.com/en-US/honorcode',
        useAbsolute: true,
      },
      {
        text: 'IP Rights',
        href: 'https://www.chegg.com/en-US/copyright',
        useAbsolute: true,
      },
    ]}
    data-test={HOME_PAGE_FOOTER_TEST}
    envUrl={Config.baseUrl}
  />
)

export default HomePageFooter
